import Vue from 'vue';
import Axios from 'axios';

const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: process.env.VUE_APP_AXIOS_TIMEOUT_MS,
});

axios.defaults.headers.common['Accept-Language'] =
  process.env.VUE_APP_DEFAULT_LOCALE_CODE;

Vue.prototype.$http = axios;

export default axios;
